import { makeStyles } from "tss-react/mui";
import { ProductForSelection } from "./AutcompleteProductTypes";
import TranslationWrapper from "../../../TranslationWrapper/TranslationWrapper";
import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import { FormattedNumber } from "react-intl";

const useStyles = makeStyles()({
  inaccessible_product: {
    color: "gray",
  },
  unavailable: {
    textDecoration: "line-through",
  },
});

export function DefaultOptionForAsyncProductAutocomplete({ option }: { option: ProductForSelection }) {
  const { inaccessible_product, unavailable } = useStyles();
  const name = option.label.length === 0 ? "Missing name" : option.label;

  return (
    <Box
      className={!option.is_actief || option.blocked ? inaccessible_product : ""}
      component={"span"}
      sx={(theme) => ({
        [theme.breakpoints.down("xl")]: {},
        gridTemplate: `"name name" "id price" "extra extra" "divider divider" / 1fr 1fr`,
        gap: 0,
        display: "inline-grid",
        // gridTemplate: `"id price name extra" / 5em 4em 1fr 1fr`,
        // gap: 2,
        width: "100%",
      })}
    >
      <Typography color={"gray"} component={"span"} sx={{ gridArea: "id" }}>
        #{option?.id ?? option.value}
      </Typography>
      <Box
        component={"span"}
        sx={{
          gridArea: "price",
          justifySelf: "end",
        }}
      >
        <FormattedNumber currency={"EUR"} style={"currency"} value={option.prijs} />
      </Box>
      <span className={option.blocked || !option.is_actief ? unavailable : ""} style={{ gridArea: "name" }}>
        {option.label}
      </span>
      <span style={{ gridArea: "extra" }}>
        {option.blocked ? (
          <b>
            <TranslationWrapper tDefault={"Product is blocked"} tKey={"async_autocomplete.product.label.is_blocked"} />
          </b>
        ) : !option.is_actief ? (
          <b>
            <TranslationWrapper
              tDefault={"Product is inactive"}
              tKey={"async_autocomplete.product.label.is_inactive"}
            />
          </b>
        ) : null}
      </span>
      <Divider sx={{ gridArea: "divider" }} />
    </Box>
  );
}
